import { Paths, PathValue } from "@mctypes/global.types";
import { useEffect } from "react";
import { McInputNew, McTextAreaNew } from "../../../../../../components";
import {
  IGKMaalingAvAvtrekksmengdeRutinekontrollResultater,
  IGKRapport,
} from "@mcapps/shared/reportSchemas/gkReportSchema";
import { beregnetLuftmengdeGjennomLukeaapning } from "../gkGlobalUtils";
import { Flex, Paper, Stack, Text, Title, Box } from "@mantine/core";
const MaalingAvAvtrekksmengdeRutinekontroll: React.FC<{
  onUpdateEditData: <P extends Paths<IGKRapport, 4>>(path: P, value: PathValue<IGKRapport, P>) => void;
  data: IGKMaalingAvAvtrekksmengdeRutinekontrollResultater;
}> = ({ data, onUpdateEditData }) => {
  useEffect(() => {
    utdataBeregninger();
  }, [data.inndata.maaleresultat, data.inndata.arealLukeaapning]);
  const utdataBeregninger = () => {
    const avtrekksLuftmengde = beregnetLuftmengdeGjennomLukeaapning(
      data.inndata.maaleresultat,
      data.inndata.arealLukeaapning,
    );
    const utdata = {
      avtrekksLuftmengde: avtrekksLuftmengde,
    };
    onUpdateEditData("testResultater.maalingAvAvtrekksmengdeRutinekontroll.utdata", utdata);
  };
  return (
    <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
      <Stack gap="xs">
        <Title order={4} fw={400}>
          Måling av avtrekksmengde ved rutinekontroll
        </Title>
        <div style={{ marginTop: 0, display: "flex", flexDirection: "column", marginBottom: "1.5rem" }}>
          <McInputNew
            label={
              <>
                {" "}
                Fyll inn lukeåpningsareal &#40;m<sup>2</sup>&#41;:{" "}
              </>
            }
            value={data.inndata.arealLukeaapning}
            onBlur={(e) =>
              onUpdateEditData(
                "testResultater.maalingAvAvtrekksmengdeRutinekontroll.inndata.arealLukeaapning",
                Number(e.target.value),
              )
            }
            normalizeNumbers={true}
            type="text"
            style={{ width: "25%" }}
          />
        </div>
        <Flex direction="column" mt="sm">
          <b>Måletiden er 60 sekunder &#40;s&#41;:</b>
        </Flex>
        <Flex direction="column" mt="sm">
          <McInputNew
            label="Fyll inn gjennomsnittlig hastighet (m/s):"
            value={data.inndata.maaleresultat}
            onBlur={(e) =>
              onUpdateEditData(
                "testResultater.maalingAvAvtrekksmengdeRutinekontroll.inndata.maaleresultat",
                Number(e.target.value),
              )
            }
            normalizeNumbers={true}
            type="text"
            style={{ width: "25%" }}
          />
        </Flex>
        <Flex justify="space-between">
          <Text mb={0}>
            Avtrekksluftmengde &#40;m<sup>3</sup>/s&#41; ={" "}
            <b>
              {beregnetLuftmengdeGjennomLukeaapning(data.inndata.maaleresultat, data.inndata.arealLukeaapning)?.toFixed(
                3,
              ) ?? ""}
            </b>
          </Text>
          <Text mb={0}>Formel: &#40;Q = Va * Aluke&#41;</Text>
        </Flex>
        <hr style={{ marginTop: 0 }} />
        <Box mt="lg" style={{ width: "50%" }}>
          <McTextAreaNew
            label="Kommentar:"
            value={data.inndata.kommentar}
            onChange={(e) =>
              onUpdateEditData("testResultater.maalingAvAvtrekksmengdeRutinekontroll.inndata.kommentar", e.target.value)
            }
          />
        </Box>
      </Stack>
    </Paper>
  );
};
export default MaalingAvAvtrekksmengdeRutinekontroll;
